import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  protected readonly http: HttpClient = inject(HttpClient);
}
